import { useCheckLogin, useLogout } from '_api';
import { InitialRouteMap } from '_constants';
import { useMemo, useEffect } from 'react';
import { useRole } from 'utils/hooks/useRole';
import { useNavigateTo } from 'utils/routeHooks';

const usePermission = () => {
  const { data: account } = useCheckLogin();
  const { role } = useRole();
  const { clear } = useLogout();
  const navigate = useNavigateTo();

  const permission = useMemo(
    () => (account ? account.accountType || undefined : undefined),
    [account],
  );

  useEffect(() => {
    if (account && role && account.accountType !== role) {
      // detected an attempt to escalate privileges.
      clear();
    }

    if (account && account.accountType === 'GUARDIAN') {
      clear();
      navigate(InitialRouteMap.LOGIN);
    }
  }, [account]);

  return { permission };
};

export default usePermission;
